/* eslint-disable @typescript-eslint/semi, no-extra-semi */

export const moveToLogin = (logoff = false, meta = '{}') => {
  const callback = `${globalThis.location.protocol}//${globalThis.location.host}`;
  const params = new URLSearchParams({
    callback,
    appOrigin: 'predicta-web',
    meta
  });

  if (logoff) {
    params.set('logout', '1');
  }

  globalThis.location = `${process.env.REACT_APP_MINHA_CONTA_SSO}?${params}` as unknown as Location;
};
